export default __webpack_public_path__ + "static/media/top1.05cd03a2.gif";